import React from "react";
import "./NewCart.Module.css";
import { Modal, Button } from "react-bootstrap";
import {  Typography, Stack, Box, Backdrop, CircularProgress, BackdropRoot, Paper, Grid, Dialog, DialogContent } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import bolsita from "../../assets/BOLSA_CARRITO.png";
import bolsaVacia from "../../assets/BOLSA_VACIA_OSCURA.png";
import { isAuthenticated } from "../../utils/auth/auth";
import ItemCart2 from "../../components/itemCart2/ItemCart2";
import { obtenerCostoProductos, obtenerPuntosProductos } from "../../utils/products/products";
import { currencyDisplay } from "../../utils/cart/cart";
import { getSales } from "../../utils/products/products";
import CarouselOfertasCart from "../../components/carousel/CarouselOfertasCart";
import { borrarCarrito } from "../../features-slice/cart/carritoSlice";
import ModalConfirmation from "../../components/modals/modalConfirmation/ModalConfirmation";
import toast from "react-hot-toast";
import { sendNewBuy } from "../../utils/cart/cart";
import { useMediaQuery } from 'react-responsive';
import PaymentButton from "../../components/paymentButton/PaymentButton";
import { getBuytById } from "../../utils/buys/buys";
import axios from 'axios';
import { getUserById } from "../../features-slice/user/functions";

export default function PantallaPagos({idCompra, close, setPantalla}) {



  const carrito = useSelector((state) => state.carrito);

    const [dataCompra, setDataCompra] = React.useState(null)

    const [costoEfect, setCostoEfect] = React.useState(0);
    const [costoTarjeta, setCostoTarjeta] = React.useState(0)
    const user = useSelector((state) => state.user.userInfo);
    const isMobile = useMediaQuery({ maxWidth: 768 }); // Cambio de imagen en pantallas pequeñas
    const [showTerms, setShowTerms] = React.useState(false)
    const handleShowTerms = () => {setShowTerms(true)}
    const handleShowTermsClose = () => {setShowTerms(false)}
    const cantidadPuntos = obtenerPuntosProductos(carrito);
    const [showSales, setShowSales] = React.useState(true);
    const [purchaseId, setPurchaseId] = React.useState("");
    const dispatch = useDispatch();

   
    //const navigate = useNavigate();

    
    const formatDetalleToText = (detalle) => {
      let formattedText = '';
      detalle.forEach((item) => {
        formattedText += `\n-${item.nombre} - Cantidad: *${item.cantidad}*, Precio: *${item.precioElegido}*, Perlas: *${item.puntos || 0}*\n\n`;
      });
      return formattedText;
    };
  const [formData, setFormData] = React.useState({
      total: 0,
      metodoPago:""
    });

    const handleEfectivo = () => {
      setFormData((prevData) => ({
        ...prevData,
        total: costoEfect,
        metodoPago:"EFECTIVO"
      }));
    };

    const handleTarjeta = () => {
      setFormData((prevData) => ({
        ...prevData,
        total: costoTarjeta,
        metodoPago:"TARJETA"
      }));
    };

    const handleClearForm = () => {
      setFormData((prevData) => ({
        ...prevData,
        total: 0,
        metodoPago:""
      }));
    };
    const fetchUserData = async () => {
      try {
     
        dispatch(getUserById(user?._id)); // Actualizamos los datos del usuario en el store de Redux
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      } finally {
 
      }
    };
  
	const token = localStorage.getItem('Token');
	const config = {
		headers: {
			xtoken: token,
		},
	};
    const handleEditPurchase = async () => {
      try {
        await axios.put(
          `${process.env.REACT_APP_BACK_URL}/api/compras/${dataCompra?._id}`,
          formData,
          config
        );
        const event = new Event('actualizar-compra');
        window.dispatchEvent(event);
        toast.success('Compra ingresada/actualizada con éxito');
        setFormData({
          total: 0,
          metodoPago:""
        });
        setPantalla(1)

        const detalleTexto = formatDetalleToText(dataCompra?.detalle);
                const numero = '+543415140700';
                const mensajeCompra = `Hola Marketina! soy ${user.nombre} ${user.apellido} y quiero hacer un pedido:\n${detalleTexto}\n idCompra: *${dataCompra._id.slice(0,5)}* \n DNI: ${user.dni.toString()} \n método de pago elegido: ${formData?.metodoPago}`;
                const encodedMensaje = encodeURIComponent(mensajeCompra);
                const whatsappLink = `https://api.whatsapp.com/send?phone=${numero}&text=${encodedMensaje}`;
        
                localStorage.removeItem('cc');
                
                dispatch(borrarCarrito());
                
                setTimeout(() => {
                	window.open(whatsappLink, '_blank');
                }, 1500);

              fetchUserData()
        close();
      } catch (error) {
        console.log(error)
        toast.error('Error al editar compra');
      }
    };


 
      React.useEffect(() => {
        const obtenerCompra = async () => {
          try {
          
            const dataPur = await getBuytById(idCompra);
            setDataCompra(dataPur);
          } catch (error) {
            toast.error('hubo un error obteniendo la compra');
          }
        };
    
        obtenerCompra();
      }, [idCompra]);

React.useEffect(() => {
  const promo = localStorage.getItem("totalPromo");
  const tarjeta = localStorage.getItem("totalTarjeta");

  if (promo && tarjeta) {
    setCostoEfect(JSON.parse(promo));
    setCostoTarjeta(JSON.parse(tarjeta));
  } else {
    // fallback normal
    const costoPromo = obtenerCostoProductos(dataCompra?.detalle, "EFECTIVO");
    const costoTarj = obtenerCostoProductos(dataCompra?.detalle, "TARJETA");
    setCostoEfect(costoPromo);
    setCostoTarjeta(costoTarj);
  }
}, [idCompra, dataCompra]);

    // console.log("data de la compra", dataCompra)
  
  return (
    <div style={{minWidth:"100%"}}>
        {
          formData?.metodoPago === "" && formData?.total === 0
          ?
          (
            <Box style={{width:"100%", display:"flex", flexDirection:"column",justifyContent:"center",alignItems:"center", gap:"24px"}}>
            <Box sx={{
                          display:"flex",
                          flexDirection:"column",
                          justifyContent:"center",
                          alignItems:"center", 
                        height:"152px",
                          minWidth:"100%", 
                          border: "1px solid #d9d9d9",
                          cursor:"pointer"
                          }}>
                <Typography sx={{
                                  fontFamily:"Poppins",
                                  fontSize:"18px",
                                  color:"black",
                                  fontWeight:600
                                }}> 
                                Efectivo en el local
                </Typography>
                <Typography sx={{
                  fontFamily:"Poppins",
                  fontSize:"18px",
                  color:"#23563F",
                  fontWeight:600
                }}> {currencyDisplay(costoEfect)}</Typography>
                <Box 
                      sx={{
                          display:"flex",
                          justifyContent:"center",
                          alignItems:"center", 
                          height:"48px",
                          width:"90%", 
                          backgroundColor:"#23563F",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          '&:hover': {
                            backgroundColor: "#1e4c36", // un poco más oscuro
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // sombrita sutil
                          }
                          // borderRadius:"5px"
                          }}
                          onClick={() =>handleEfectivo()}                             
                          >
                  <Typography sx={{
                    fontFamily:"Poppins",
                    color:"#ffff",
                    fontSize:"14px",
                    fontWeight:400
                  }}>Seleccionar este método de pago</Typography>
                </Box>
            </Box>
            <Box sx={{
                          display:"flex",
                          flexDirection:"column",
                          justifyContent:"center",
                          alignItems:"center", 
                        height:"152px",
                          minWidth:"100%", 
                          border: "1px solid #d9d9d9",
                                cursor:"pointer"
                          }}>
                <Typography sx={{                  
                                  fontFamily:"Poppins",
                                  fontSize:"18px",
                                  color:"black",
                                  fontWeight:600
                                }}> 
                                Transferencia o tarjeta en el local
                </Typography>
                <Typography sx={{
                  fontFamily:"Poppins",
                  fontSize:"18px",
                  color:"#23563F",
                  fontWeight:600
                }}> {currencyDisplay(costoTarjeta)}</Typography>
                <Box sx={{
                          display:"flex",
                          justifyContent:"center",
                          alignItems:"center", 
                          height:"48px",
                          width:"90%", 
                          backgroundColor:"#23563F",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          '&:hover': {
                            backgroundColor: "#1e4c36", // un poco más oscuro
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)", // sombrita sutil
                          }
                          // borderRadius:"5px"
                          }}
                          onClick={() =>handleTarjeta()} 
                          >
                  <Typography sx={{
                    fontFamily:"Poppins",
                    color:"#ffff",
                    fontSize:"14px",
                    fontWeight:400
                  }}>Seleccionar este método de pago</Typography>
                </Box>
                
            </Box>

            <Box sx={{
                          display:"flex",
                          flexDirection:"column",
                          justifyContent:"center",
                          alignItems:"center", 
                        minHeight:"180px",
                          minWidth:"100%", 
                          border: "1px solid #d9d9d9"
                          }}>
                <Typography sx={{
                                  fontFamily:"Poppins",
                                  fontSize:"18px",
                                  color:"black",
                                  fontWeight:600
                                }}> 
                                Mercado Pago
                </Typography>
                <Typography sx={{
                  fontFamily:"Poppins",
                  fontSize:"18px",
                  color:"#23563F",
                  fontWeight:600
                }}> {currencyDisplay(costoTarjeta)}</Typography>
        {
            idCompra &&  (
        
               
                  <Box sx={{width:"90%"}}>
                    <PaymentButton compraId={idCompra}/>
                  </Box>
                  
     
              
            )
          }
                
            </Box>
         
              <Typography 
                sx={{
                  fontFamily:"Poppins",
                  fontSize:"14px",
                  color:"#5c5c5c",
                  fontWeight:400,
                  cursor:"pointer"
                }}
                onClick={() =>close()}
                > Pagar en otro momento
          </Typography>		
          </Box>
      
          ):(
<Box style={{width:"100%", display:"flex", flexDirection:"column",justifyContent:"center",alignItems:"center", gap:"24px"}}>
            <Box sx={{
                          display:"flex",
                          flexDirection:"column",
                          justifyContent:"center",
                          alignItems:"center", 
                        height:"152px",
                          minWidth:"100%", 
                          border: "1px solid #d9d9d9"
                          }}>
                <Typography sx={{
                                  fontFamily:"Poppins",
                                  fontSize:"18px",
                                  color:"black",
                                  fontWeight:600
                                }}> 
                               {formData?.metodoPago === "EFECTIVO" ?  "Seleccionaste Efectivo en el local":"Seleccionaste Transferencia o tarjeta en el local"}
                </Typography>
                <Typography sx={{
                  fontFamily:"Poppins",
                  fontSize:"18px",
                  color:"#23563F",
                  fontWeight:600
                }}> {currencyDisplay(formData.metodoPago === "EFECTIVO"? costoEfect : costoTarjeta)}</Typography>
                <Box 
                      sx={{
                          display:"flex",
                          justifyContent:"center",
                          alignItems:"center", 
                          height:"48px",
                          width:"90%", 
                          backgroundColor:"#23563F",
                          cursor:"pointer"
                          // borderRadius:"5px"
                          }}
                          onClick={() =>handleEditPurchase()}    
                          
                          >
                  <Typography sx={{
                    fontFamily:"Poppins",
                    color:"#ffff",
                    fontSize:"14px",
                    fontWeight:400
                  }}>Confirmar</Typography>
                </Box>
                
            </Box>
  
              <Typography 
                sx={{
                  fontFamily:"Poppins",
                  fontSize:"14px",
                  color:"#5c5c5c",
                  fontWeight:400,
                  cursor:"pointer"
                }}
                onClick={() =>handleClearForm()}
                > Seleccionar otro
          </Typography>		
          </Box>
          )
        }
          
      
    </div>
  )
}
